import styled from 'styled-components';

export const BottomImage = styled.img`
  position: relative;
  bottom: 0%;
  right: 0%;
  width: 80%;
  transform: translate(20%, 0%);
  z-index: 2;
`;

export const BulbImage = styled.img`
  position: relative;
  top: 0%;
  left: 0%;
  width: 15%;
  transform: translate(0%, 0%);
  z-index: 2;
  padding-bottom: 30px;
`;

export const Container = styled.div`
  font-family: 'Graphik Medium', 'Graphik', sans-serif;
  overflow: hidden;
  background-color: #F4F4F2;
  z-index: 1;
  height: 98%;
`;

export const HeaderDiv = styled.div`
  font-size: 40px;
  line-height: 42px;
  color: #003D50;
  font-weight: bold;
  padding-bottom: 20px;
`;

export const SubHeaderDiv = styled.div`
  font-size: 22px;
  line-height: 24px;
  color: #003D50;
  font-weight: bold;
  padding-bottom: 20px;
`;

export const TextDiv = styled.div`
  font-size: 18px;
  line-height: 20px;
  color: #003D50;
`;

export const InfoDiv = styled.div`
  margin-top: 10%;
  margin-left: 10%;
  z-index: 2;
  height: 360px;
`;

export const TopImage = styled.img`
  position: relative;
  top: 0%;
  left: 0%;
  width: 30%;
  transform: translate(0%, 0%);
  z-index: 2;
`;